import queryString from "query-string";
import { isEmpty } from "lodash";
import * as types from "./actionTypes";
import { showAlertSuccess } from "./alertActions";
import reportService from "../services/reportService";
import { toggleLoader } from "./loaderActions";

export function getCustomerProjectStatusReportSuccess(report) {
  return {
    type: types.GET_CUSTOMER_PROJECT_STATUS_REPORT_SUCCESS,
    report
  };
}

export function getCallDetailReportSuccess(report) {
  return {
    type: types.GET_CALL_DETAIL_REPORT_SUCCESS,
    report
  };
}

export function getResourceSummaryReportSuccess(resource_summary) {
  return {
    type: types.GET_RESOURCE_SUMMARY_REPORT_SUCCESS,
    resource_summary_report: resource_summary.data
  };
}

export function getCustomerProjectStatusReport(payload) {
  return (dispatch) => {
    dispatch(toggleLoader(true));
    return reportService
      .post("/customer-project-status", payload)
      .then((data) => dispatch(getCustomerProjectStatusReportSuccess(data)))
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")))
      .finally(() => dispatch(toggleLoader(false)));
  };
}

export function getProjectSummaryByCustomerReport(payload) {
  return (dispatch) =>
    reportService
      .post("/project-summary-by-customer", payload)
      .then((data) => data)
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function getCallDetailReport(payload) {
  return (dispatch) =>
    reportService
      .post("/call-details", payload)
      .then((data) => data)
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function getTaskDetailReport(payload) {
  return (dispatch) =>
    reportService
      .post("/task-details", payload)
      .then((data) => data)
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function getMonthlyRevenueAnalysisReportSuccess(report) {
  return {
    type: types.GET_MONTHLY_REVENUE_ANALYSIS_REPORT_SUCCESS,
    report
  };
}

export function cleanMRAReport() {
  return {
    type: types.CLEAN_MRA_REPORT
  };
}

export function getMonthlyRevenueAnalysisReport(payload) {
  return (dispatch) => {
    dispatch(toggleLoader(true));
    return reportService
      .post("/monthly-revenue-analysis", payload)
      .then((data) => dispatch(getMonthlyRevenueAnalysisReportSuccess(data)))
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")))
      .finally(() => dispatch(toggleLoader(false)));
  };
}

export function getCustomerBalanceSummaryReport(payload) {
  return (dispatch) =>
    reportService
      .post("/customer-balance", payload)
      .then((data) => data)
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function getResourceSummary(params) {
  let url = `/resource-summary`;
  if (params && params.filtered && !isEmpty(params.filtered)) {
    const param = `&${queryString.stringify(
      { ...params.filtered, ...params.sorted },

      { arrayFormat: "bracket" }
    )}`;

    url = url.concat(`?${param}`);
  }
  return (dispatch) =>
    reportService
      .get(url)
      .then((data) => dispatch(getResourceSummaryReportSuccess(data)))
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function clearResourceSummary() {
  return {
    type: types.CLEAR_RESOURCE_SUMMARY
  };
}

export function clearReport() {
  return {
    type: types.CLEAR_REPORT
  };
}

export function getDailyCallCompletionReportSuccess(report) {
  return {
    type: types.GET_DAILY_CALL_COMPLETION_REPORT_SUCCESS,
    report
  };
}

export function getDailyCallCompletionReport(payload) {
  const params = `&${queryString.stringify(payload, {
    arrayFormat: "bracket"
  })}`;
  return (dispatch) => {
    dispatch(toggleLoader(true));
    return reportService
      .get(`/daily-call-completion?${params}`, payload)
      .then((data) => dispatch(getDailyCallCompletionReportSuccess(data)))
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")))
      .finally(() => dispatch(toggleLoader(false)));
  };
}

export function getOpenSupportTicketsReportSuccess(report) {
  return {
    type: types.GET_OPEN_SUPPORT_TICKETS_REPORT_SUCCESS,
    report
  };
}

export function getOpenSupportTicketsReport(payload) {
  const params = `&${queryString.stringify(payload, {
    arrayFormat: "bracket"
  })}`;
  return (dispatch) => {
    dispatch(toggleLoader(true));
    return reportService
      .get(`/open-support-tickets?${params}`, payload)
      .then((data) => dispatch(getOpenSupportTicketsReportSuccess(data)))
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")))
      .finally(() => dispatch(toggleLoader(false)));
  };
}

export function clearProjectServiceAnalysisReport() {
  return {
    type: types.CLEAR_PROJECT_SERVICE_ANALYSIS_REPORT
  };
}

export function getProjectServiceAnalysisReportSuccess(report) {
  return {
    type: types.GET_PROJECT_SERVICE_ANALYSIS_REPORT_SUCCESS,
    report
  };
}

export function getProjectServiceAnalysisReport(payload) {
  const params = `&${queryString.stringify(payload, {
    arrayFormat: "bracket"
  })}`;
  return (dispatch) => {
    dispatch(toggleLoader(true));
    return reportService
      .get(`/project-service-analysis?${params}`, payload)
      .then((data) => dispatch(getProjectServiceAnalysisReportSuccess(data)))
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")))
      .finally(() => dispatch(toggleLoader(false)));
  };
}

export function getSupportTicketDetailReport(payload) {
  return (dispatch) =>
    reportService
      .post("/support-ticket-details", payload)
      .then((data) => data)
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}
